module.exports = __webpack_public_path__ + "static/media/20.ae21e390.jpg";